module.exports = __webpack_public_path__ + "static/media/COSTILLASALSA_MENU-normal.54ffa6a9.png";